// extracted by mini-css-extract-plugin
export default {"editButton":"closingPayrollmonth_editButton__BRbap","TableBody":"closingPayrollmonth_TableBody__JBOlF","StopButton":"closingPayrollmonth_StopButton__cMnBJ"};